import { StatsContextLeadInterface } from 'pf-frontend-common/src/module/stats/context/lead.interface';

import { LeadEmailFormInputInterface } from 'common/module/lead/email/form/input.interface';

export class LeadStatsLeadContextAdapter {
  /**
   * Constructor
   */
  constructor(private input: LeadEmailFormInputInterface, private isViewing: boolean) {}

  /**
   * Returns a LeadEmailFormInputInterface as a StatsContextLeadInterface
   */
  public getData(): StatsContextLeadInterface {
    const context: StatsContextLeadInterface = {
      medium: 'email',
      cta: 'button',
      email: {
        name: this.input.name.value,
        email: this.input.email.value,
        phone: this.input.phone.value,
        message: this.input.message.value,
      },
    };

    if (this.isViewing) {
      context.variation = 'viewing';
    }

    if (this.input.createAlert) {
      context.email.emailAlert = this.input.createAlert.value;
    }

    if (this.input.enquiryType) {
      context.email.enquiryType = this.input.enquiryType.value;
    }

    return context;
  }
}
